import script from "./NextChallenge.vue?vue&type=script&setup=true&lang=js"
export * from "./NextChallenge.vue?vue&type=script&setup=true&lang=js"

import "./NextChallenge.vue?vue&type=style&index=0&id=cc18a70e&scoped=true&lang=css"

import exportComponent from "/Users/ffavreau/www/canton-dans-le-bouillon/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc18a70e"]])

export default __exports__